import { useLocaleContext } from '@shared/core/i18n/LocaleContext';

/**
 * List of country codes that use the imperial system for distance (i.e., miles).
 * These are typically used to infer whether a user prefers miles over kilometers.
 */
export const IMPERIAL_CULTURES = ['US', 'GB', 'LR', 'MM'] as const;

/**
 * Hook to determine whether the current user's locale corresponds to a country
 * that uses the imperial system for measuring distance (e.g., miles).
 *
 * This is useful for adapting UI elements like travel distance formatting
 * based on regional preferences.
 *
 * @returns `true` if the user's locale region uses miles, otherwise `false`.
 */
export const useIsImperialCultures = (): boolean => {
  const { language } = useLocaleContext();
  const region = new Intl.Locale(language).region?.toUpperCase();
  const mileCountries = new Set(IMPERIAL_CULTURES as unknown as string[]);

  return mileCountries.has(region ?? '');
};
